const processNvitPackProducts = (headers, invoiceItems, payload, transData, restOrder) => {
  let getHeaders = ''
  let getContent = ''
  const rightAlignCols = ['hs', 'qty', 'netweight_total', 'grossweight_total']
  for (let i = 0; i < headers.length; i++) {
    if (rightAlignCols.includes(headers[i].value)) {
      getHeaders += `<th class="th-fontsize text-right" width="${headers[i].width}">${headers[i].text}</th>`
    } else {
      getHeaders += `<th class="th-fontsize" width="${headers[i].width}">${headers[i].text}</th>`
    }
  }
  for (let j = 0; j < invoiceItems.length; j++) {
    getContent += `<tr class="to_new_line ${j > 0 ? 'comments_border_remove' : ''}">`
    for (let i = 0; i < headers.length; i++) {
      const val = invoiceItems[j][headers[i].value] || ''
      if (rightAlignCols.includes(headers[i].value)) {
        getContent += `<td class="th-fontsize text-right">${val}</td>`
      } else {
        getContent += `<td class="th-fontsize">${val}</td>`
      }
    }
    getContent += '</tr>'
  }
  // Totals rows — label spans first 4 cols, value in netweight_total col (5th), comments col (6th) empty
  getContent += `
    <tr style="border-top: 2px solid #888;">
      <td colspan="4" class="th-fontsize text-right"><b>${transData.totalNetWeightLabel}:</b></td>
      <td class="th-fontsize text-right"><b>${transData.totalNetWeight || '0'}</b></td>
      <td></td>
    </tr>
    <tr>
      <td colspan="4" class="th-fontsize text-right"><b>${transData.totalGrossWeightLabel}:</b></td>
      <td class="th-fontsize text-right"><b>${transData.totalGrossWeight || '0'}</b></td>
      <td></td>
    </tr>`
  return content(getHeaders, getContent, payload, transData, restOrder)
}
const content = (headers, content, payload, transData, restOrder) => btoa(unescape(encodeURIComponent(`<!DOCTYPE html>
<html>
  <head>
    <meta content="text/html; charset=utf-8" http-equiv="Content-Type"/>
    <link rel="stylesheet" href="https://maxcdn.bootstrapcdn.com/bootstrap/3.4.1/css/bootstrap.min.css">
    <style>
    @page { size: A4 landscape; margin: 10mm; }
    .footer {
      position: fixed;
      left: 0;
      bottom: 0;
      width: 100%;
      text-align: center;
    }
    .table-condensed>tbody>tr:nth-of-type(even) {
      background-color: #f9f9f9;
    }
    .comments_border_remove td {
      border-top: none !important;
    }
    thead tr { page-break-inside:avoid; }
    tbody tr, .to_new_line { page-break-inside:avoid; }
    tbody tr td { word-break: break-word; }
    body {
      font-family: "Helvetica Neue",Helvetica,Arial,sans-serif;
      letter-spacing: 0.3px;
      font-size: 16px !important;
    }
    .table-content {
      font-family: "Helvetica Neue",Helvetica,Arial,sans-serif;
    }
    .table-condensed>tbody>tr>td, .table-condensed>tbody>tr>th, .table-condensed>tfoot>tr>td, .table-condensed>tfoot>tr>th, .table-condensed>thead>tr>td, .table-condensed>thead>tr>th {
      padding: 4px 5px !important;
    }
    .header-font-size {

    }
    </style>
  </head>
  <body>
  <div class="container-fluid">
    <div class="row">
      <div class="col-xs-12">
        <table style="width: 100%;">
          <tr>
            <td width="45%" rowspan=2 class="header-font-size" style="vertical-align:top">
              <div>
                <span>${payload.customername || ''}</span><br>
                <span>${payload.customeraddress_address || ''}</span><br>
                ${payload.customeraddress_address2 ? `<span>${payload.customeraddress_address2 || ''}</span><br>` : ''}
                <span>${payload.customeraddress_postcode || ''} ${payload.customeraddress_city || ''}</span><br>
              </div>
            </td>
            <td width="30%">
              <div>
                <span>Kilab AS, 912195759</span><br>
                <span>Majorvegen 22, 2030 Nannestad</span><br>
                <span>firmapost@kilab.no &nbsp &nbsp &nbsp www.kilab.no</span><br><br>
              </div>
            </td>
            <td width="25%" style="vertical-align:top">
              <img class="img-responsive pull-right" height="180" width="180" src="https://kilabapi.apphouse.no/kilab_logo.png" alt="kilab">
            </td>
          </tr>
          <tr>
            <td colspan=2>
              <div class="row">
                <div class="col-xs-6 col-xs-offset-1 text-left">

                </div>
                <div class="col-xs-5 text-right">
                <h4 style="font-size:18px"><b>${transData.confirm}</b></h4>
                </div>
              </div>
            </td>
          </tr>
        </table>

      </div>
      <div class="col-xs-7 header-font-size">
        <div class="row">
          <div class="col-xs-6" style="margin-right: 0px;margin-top: 5px;">
            <span><b>${transData.deliveryAddress}</b></span><br>
              <span>${payload.customername || ''}</span>
              <div>
                <span>${payload.deliveryaddress_address || ''}</span><br>
                ${payload.deliveryaddress_address2 ? `<span>${payload.deliveryaddress_address2 || ''}</span><br>` : ''}
                <span>${payload.deliveryaddress_postcode || ''} ${payload.deliveryaddress_city || ''}</span>
              </div>
          </div>
        </div>
      </div>
      <div class="col-xs-5 header-font-size">

        <hr style="margin: 1px;" />
        <table style="width: 100%">
          <tr>
            <td width="50%">${transData.number}:</td>
            <td width="50%" class="text-right">${payload.number || ''}</td>
          </tr>
          <tr>
            <td width="50%">${transData.customerNum}:</td>
            <td width="50%" class="text-right">${payload.customernumber || ''}</td>
          </tr>
          <tr>
            <td width="50%">${transData.saleRef}:</td>
            <td width="50%" class="text-right">${payload.salesreference || ''}</td>
          </tr>
          <tr>
            <td width="50%">${transData.ourreference}:</td>
            <td width="50%" class="text-right">${payload.ourreferencename || ''}</td>
          </tr>
          <tr>
            <td>${transData.shipment}:</td>
            <td class="text-right">${payload.shipmentname || ''}</td>
          </tr>
          <tr>
            <td>${transData.yourreference}:</td>
            <td class="text-right">${payload.yourreference || ''}</td>
          </tr>
          <tr>
            <td>${transData.yourOrderNum}:</td>
            <td class="text-right">${payload.yourordernumber || ''}</td>
          </tr>
          <tr>
            <td>${transData.contact}:</td>
            <td class="text-right">${payload.contactname || ''}</td>
          </tr>
          <tr>
            <td>${transData.contactPhone}:</td>
            <td class="text-right">${payload.contactphone || ''}</td>
          </tr>
          <tr>
            <td>${transData.labeled}:</td>
            <td class="text-right">${payload.labeled || ''}</td>
          </tr>
        </table>

      </div>
      <div class="col-xs-12 table-content">
        <table class="table table-condensed" style="width: 100%">
          <tbody>
            <tr>
              ${headers}
            </tr>

            ${content}
          </tbody>
        </table>
      </div>
    </div>
  </div>
</body>
</html>`)))
export default processNvitPackProducts
